export const getCounts = store => store.reports.counts
export const getDialogOpen = store => store.reports.dialogOpen
export const getReportType = store => store.reports.reportType
export const getReportOptions = store => store.reports.options
export const getReportData = store => store.reports.data
